import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OrdersourceService {

  constructor(private http: HttpClient) { }

  getAllGroups() {
    return this.http.get<any>(`${environment.inventoryURl}Group`);
  }

  getAllSourceTypes(groupId) {
    return this.http.get<any>(`${environment.inventoryURl}Type?groupId=${groupId}`);
  }

  getOrderSourceList() {
    
    return this.http.get<any>(`${environment.inventoryURl}OrderSource`);
  }

  deleteOrderSource(id) {
    return this.http.delete<any>(`${environment.inventoryURl}OrderSource/${id}`)
      .toPromise()
      .then(res => res);
  }

  addOrderSource(data) {
    return this.http.post<any>(`${environment.inventoryURl}OrderSource`, data)
      .toPromise()
      .then(res => res);
  }

  updateOrderSource(data) {
    return this.http.put<any>(`${environment.inventoryURl}OrderSource`, data)
      .toPromise()
      .then(res => res);
  }
}
